module.exports = __webpack_public_path__ + "static/media/lightVideo.55acf849.svg";